var t = /* @__PURE__ */ ((n) => (n.PAYMENT_INTENT = "payment_intent", n.SETUP_INTENT = "setup_intent", n))(t || {});
export {
  t as StripeObjectType
};
